
export type VoteOnPollBody = {
  /** ID of the option to vote for */
  optionId: string;
};
